import { useEffect } from 'react';

/**
 * Custom hook that sets up an interval to repeatedly call a function.
 *
 * @param fn - The function to be called at each interval.
 * @param timeout - The time (in milliseconds) between each function call.
 */
function useInterval(fn: () => void, timeout: number) {
  useEffect(() => {
    const id = setInterval(fn, timeout);
    return () => clearInterval(id);
  }, [fn, timeout]);
}

export default useInterval;
